var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cash-audit"},[_c('div',{staticClass:"tip"},[_vm._v("提现申请已提交，等待人工审核")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"bnt bg-color-red",on:{"click":function($event){return _vm.$router.push({ path: '/user/user_promotion' })}}},[_vm._v("\n    好的\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }